import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'tcomponents/atoms/FontIcon';
import { NO_OP } from '../../../constants/Constants';
import '../CheckboxPalette.scss';
class PaletteRowExpand extends React.PureComponent {
  render() {
    const {
      onExpand,
      expanded
    } = this.props;
    return /*#__PURE__*/React.createElement(FontIcon, {
      size: 12,
      onClick: () => onExpand()
    }, expanded ? 'icon-caret-down' : 'icon-caret-right');
  }
}
PaletteRowExpand.propTypes = {
  expanded: PropTypes.bool,
  onExpand: PropTypes.func
};
PaletteRowExpand.defaultProps = {
  expanded: false,
  onExpand: NO_OP
};
export default PaletteRowExpand;